/* tslint:disable */
/* eslint-disable */
/* @relayHash b12b1465b07b827d65b43ec315b31d5b */

import { ConcreteRequest } from "relay-runtime";
export type ShipmentQuoteRequestInput = {
    buyerId: string;
    itemPk?: string | null;
    itemIds?: Array<string | null> | null;
    dealerPk?: string | null;
    message: string;
    subject: string;
    action?: string | null;
    pageContext?: string | null;
    transactionId?: string | null;
    conversationId?: string | null;
    city?: string | null;
    state?: string | null;
    country?: string | null;
    zipCode?: string | null;
    currencyConversionRateEventId?: string | null;
    shippingAddressId?: string | null;
    portfolioIds?: Array<string | null> | null;
    conversationIds?: Array<string | null> | null;
    clientMutationId?: string | null;
};
export type requestShipmentQuoteMutationVariables = {
    input: ShipmentQuoteRequestInput;
};
export type requestShipmentQuoteMutationResponse = {
    readonly shipmentQuoteRequest: {
        readonly conversation: {
            readonly id: string;
            readonly serviceId: string | null;
            readonly transaction: {
                readonly id: string;
                readonly serviceId: string | null;
            } | null;
        } | null;
    } | null;
};
export type requestShipmentQuoteMutation = {
    readonly response: requestShipmentQuoteMutationResponse;
    readonly variables: requestShipmentQuoteMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ShipmentQuoteRequestPayload",
    "kind": "LinkedField",
    "name": "shipmentQuoteRequest",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Conversation",
        "kind": "LinkedField",
        "name": "conversation",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Transaction",
            "kind": "LinkedField",
            "name": "transaction",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "requestShipmentQuoteMutation",
    "selections": (v3/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "requestShipmentQuoteMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "app-buyer-finding/308.0.0-2021-04-02T13:56:48.892Z/requestShipmentQuoteMutation",
    "metadata": {},
    "name": "requestShipmentQuoteMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = '0907d83770d95f82e909f436c2af3af8';
export default node;
